import styled from 'styled-components';
import { Image } from 'app/shared/components/Image/Image';

export const BackgroundSt = styled(Image)`
  top: 50%;
  left: 50%;
  filter: blur(10px);
  width: 100%;
  height: 100%;
  position: relative;
  transform: translate(-50%, -50%);
`;

interface IImageStProps {
  withBackground?: boolean;
}

export const ImageSt = styled(Image)<IImageStProps>`
  position: ${({ withBackground }) =>
    !withBackground ? 'relative' : 'absolute'};
  top: 50%;
  left: 50%;
  width: ${({ withBackground }) => !withBackground && '100%'};
  transform: translate(-50%, -50%);
`;

export const FullImageSt = styled(Image)`
  height: 100%;
  object-fit: contain;
`;
